import React from 'react'

import type { MapRef } from 'react-map-gl/mapbox'

import { ListCounts, ListPageToolbar, LayoutSwitch } from '@/components/ui/list-page/ListPageToolbar'
import { ListSearch } from '@/components/ui/list-page/ListSearch'

import { AssetListControls } from './AssetListControls'
import { AssetSavedViews } from './AssetSavedViews'
import { Filters, useMapContext } from './MapContext'
import { MapFilters } from './MapFilters'
import { CompanyControls } from './TopNavMapControls'

interface MapToolbarProps {
  mapRef: React.RefObject<MapRef | null>
  activeFilter: keyof Filters | undefined
  setActiveFilter: (filter: keyof Filters | undefined) => void
}

export const MapToolbar = ({ mapRef, activeFilter, setActiveFilter }: MapToolbarProps) => {
  const context = useMapContext()
  const { filteredAssets, viewportFilteredAssets, allAssets } = context

  return (
    <ListPageToolbar
      title="Assets"
      sheetIsOpen={context.assetDetailSheetIsOpen}
      savedViews={<AssetSavedViews mapRef={mapRef} />}
      search={
        <ListSearch
          id="search-assets"
          placeholder="Search assets..."
          value={context.searchTerm}
          onChange={context.setSearchTerm}
        />
      }
      counts={
        <ListCounts
          updatedAt={context.updatedAt}
          count={
            context.sidebarState.limitToMap && viewportFilteredAssets.length !== filteredAssets.length
              ? `${viewportFilteredAssets.length.toLocaleString()} visible · ${filteredAssets.length.toLocaleString()} matching · ${allAssets.length.toLocaleString()} total`
              : `${filteredAssets.length.toLocaleString()} of ${allAssets.length.toLocaleString()} assets`
          }
        />
      }
      scope={<CompanyControls mapRef={mapRef} />}
      listControls={<AssetListControls />}
      layoutSwitch={
        <LayoutSwitch
          mode={context.sidebarState.layoutMode}
          onChange={(layoutMode) => context.setSidebarState((prev) => ({ ...prev, layoutMode }))}
        />
      }
      filters={<MapFilters activeFilter={activeFilter} setActiveFilter={setActiveFilter} />}
    />
  )
}
